export default __webpack_public_path__ + "static/media/img5.ff9b03a4.png";